import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export function ServiceCompanyInvite() {
  this.getListCompanyInvites = async id => new Promise((resolve, reject) => {
    axios.get(`company-invites/invitable-specialists/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.sendInvite = async data => new Promise((resolve, reject) => {
    axios.post('company-invites/send-invite', data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.acceptInvite = async data => new Promise((resolve, reject) => {
    axios.post('company-invites/accept-invite', data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.rejectInvite = async data => new Promise((resolve, reject) => {
    axios.post('company-invites/reject-invite', data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.getCompanyInvites = async () => new Promise((resolve, reject) => {
    axios.get('company-invites/received-invites')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
